module.exports = __webpack_public_path__ + "assets/img/00028.3762ee7d.png";